import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useScreenInit } from './useScreenInit.js';
import { Header } from './components/Header';
import { WelcomeScreen } from './components/WelcomeScreen';
import { QuestionScreen, Option } from './components/QuestionScreen';
import { ResultsScreen } from './components/ResultsScreen';
import { AnalyzingScreen } from './components/AnalyzingScreen';
const QUIZ_DATA = [{
  id: 1,
  question: '¿Cuál es tu situación actual?',
  options: [{
    id: '1a',
    emoji: '🏠',
    text: 'Estoy en casa y quiero generar mis propios ingresos'
  }, {
    id: '1b',
    emoji: '💼',
    text: 'Tengo trabajo pero quiero un ingreso extra'
  }, {
    id: '1c',
    emoji: '🌿',
    text: 'Estoy jubilada y busco algo activo y relajante'
  }, {
    id: '1d',
    emoji: '🚀',
    text: 'Quiero armar un negocio serio desde cero'
  }]
}, {
  id: 2,
  question: '¿Qué te frena hoy para empezar?',
  options: [{
    id: '2a',
    emoji: '😟',
    text: 'No sé cómo hacer la masa ni los sahumerios'
  }, {
    id: '2b',
    emoji: '💸',
    text: 'Tengo miedo de invertir y perder plata'
  }, {
    id: '2c',
    emoji: '📦',
    text: 'No sé cómo vender ni conseguir clientes'
  }, {
    id: '2d',
    emoji: '🤷',
    text: 'No sé si es rentable de verdad'
  }]
}, {
  id: 3,
  question: '¿Qué tipo de sahumerios te gustaría fabricar?',
  options: [{
    id: '3a',
    emoji: '🌙',
    text: 'Zodiacales y energéticos (los más vendidos)'
  }, {
    id: '3b',
    emoji: '🌸',
    text: 'Florales y aromáticos premium'
  }, {
    id: '3c',
    emoji: '🎨',
    text: 'Peluditos, bicolor y formas especiales'
  }, {
    id: '3d',
    emoji: '💰',
    text: 'Los que más se vendan, sin importar cuál'
  }]
}, {
  id: 4,
  question: '¿Cuánto tiempo tenés disponible por día para tu emprendimiento?',
  options: [{
    id: '4a',
    emoji: '⏰',
    text: 'Menos de 1 hora'
  }, {
    id: '4b',
    emoji: '🕐',
    text: 'Entre 1 y 3 horas'
  }, {
    id: '4c',
    emoji: '🕓',
    text: 'Medio día'
  }, {
    id: '4d',
    emoji: '🗓️',
    text: 'Quiero dedicarme full time'
  }]
}, {
  id: 5,
  question: '¿Cuál es tu meta principal con este negocio?',
  options: [{
    id: '5a',
    emoji: '💵',
    text: 'Ganar mis primeros $500.000 pesos este mes'
  }, {
    id: '5b',
    emoji: '🏡',
    text: 'Tener un ingreso fijo desde casa'
  }, {
    id: '5c',
    emoji: '🎁',
    text: 'Vender en ferias, Marketplace y redes'
  }, {
    id: '5d',
    emoji: '🌟',
    text: 'Crear mi propia marca de sahumerios premium'
  }]
}];
export function App() {
  const init = useScreenInit();
  const [step, setStep] = useState(init.step ?? 0);
  const [answers, setAnswers] = useState<Record<number, string>>({});
  const handleNext = () => {
    window.scrollTo(0, 0);
    setStep(prev => Math.min(prev + 1, 7));
  };
  const handleSelectOption = (questionId: number, optionId: string) => {
    setAnswers(prev => ({
      ...prev,
      [questionId]: optionId
    }));
  };
  // Render logic based on step
  let content;
  if (step === 0) {
    content = <WelcomeScreen onNext={handleNext} data-id="element-0" />;
  } else if (step >= 1 && step <= 5) {
    const questionData = QUIZ_DATA[step - 1];
    content = <QuestionScreen question={questionData.question} options={questionData.options} selectedOptionId={answers[questionData.id]} onSelect={optionId => handleSelectOption(questionData.id, optionId)} onNext={handleNext} data-id="element-1" />;
  } else if (step === 6) {
    content = <AnalyzingScreen onComplete={handleNext} data-id="element-2" />;
  } else {
    content = <ResultsScreen data-id="element-3" />;
  }
  return <div className="min-h-screen bg-stone-100 flex justify-center" data-id="element-4">
      <div className="w-full max-w-md bg-white shadow-2xl relative flex flex-col min-h-screen overflow-hidden" data-id="element-5">
        {step < 6 && <Header step={step} totalSteps={5} data-id="element-6" />}
        <main className="flex-grow flex flex-col relative" data-id="element-7">
          <AnimatePresence mode="wait" data-id="element-8">
            <motion.div key={step} initial={{
            opacity: 0,
            x: 40
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -40
          }} transition={{
            duration: 0.35,
            ease: [0.22, 1, 0.36, 1]
          }} className="flex-grow flex flex-col" data-id="element-9">
              {content}
            </motion.div>
          </AnimatePresence>
        </main>
      </div>
    </div>;
}